<template>
  <Breadcrumb :items="items" class="hidden md:flex text-primary-700 mb-5 lg:mb-3" />
</template>

<script setup lang="ts">
import type { Category } from '@robustastudio/e-commerce/common';

defineComponent({
  name: 'CategoryBreadcrumb',
});
const category = inject(CATEGORY_CONTEXT) as Ref<Category>;
const { t } = useI18n();

const { data: flatCategories } = useAsyncData(async () => {
  const { flatCategories } = await useCategories();
  return flatCategories;
});

const categories = computed(() => {
  return category.value?.url?.split('/').map((item: string) => {
    return flatCategories.value?.find(category => category.url?.includes(item));
  });
});

const items = computed(() => [
  {
    label: t('home'),
    path: '/',
  },
  // { label: flatCategories.value[0]?.name, path: flatCategories.value[0]?.url_key },
  ...(categories.value
    ?.filter(category => category?.id?.toString() !== ROOT_CATEGORY_ID)
    .map(category => {
      return {
        label: category?.name as string,
        path: category?.url_key ? `/${category?.url_key}` : '/',
      };
    }) || []),
]);
</script>
<i18n>
{
  "en": {
    "home": "Home"
  },
  "ar": {
    "home": "الرئيسية"
  }
}
</i18n>
